import { render, staticRenderFns } from "./PasswordFindApproval.vue?vue&type=template&id=e0a12cc4&scoped=true"
import script from "./PasswordFindApproval.vue?vue&type=script&lang=js"
export * from "./PasswordFindApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a12cc4",
  null
  
)

export default component.exports